import React, { useState, useEffect } from 'react';
import { collection, query, orderBy, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import Hero from '../components/Hero';
import MovieRow from '../components/MovieRow';
import Footer from '../components/Footer';
import { fetchTrending, fetchTopRated, fetchNowPlaying, fetchByGenre } from '../api/tmdb';

// Normalise Firestore custom doc → TMDB-compatible shape
const normaliseCustom = (raw) => ({
  id:           'custom_' + raw.id,
  _customId:    raw.id,
  title:        raw.title       || '',
  overview:     raw.description || '',
  description:  raw.description || '',
  release_date: raw.releaseYear ? `${raw.releaseYear}-01-01` : '',
  releaseYear:  raw.releaseYear,
  vote_average: parseFloat(raw.rating) || 0,
  rating:       parseFloat(raw.rating) || 0,
  poster_path:  null,
  backdrop_path:null,
  posterUrl:    raw.posterUrl   || '',
  backdropUrl:  raw.backdropUrl || '',
  youtubeId:    raw.youtubeId   || '',
  genre:        raw.genre       || '',
  featured:     raw.featured    || false,
  source:       'custom',
});

const HomePage = () => {
  const [trending,      setTrending]      = useState([]);
  const [topRated,      setTopRated]      = useState([]);
  const [nowPlaying,    setNowPlaying]    = useState([]);
  const [action,        setAction]        = useState([]);
  const [comedy,        setComedy]        = useState([]);
  const [drama,         setDrama]         = useState([]);
  const [customMovies,  setCustomMovies]  = useState([]);
  const [loadingTmdb,   setLoadingTmdb]   = useState(true);

  // ── TMDB data ────────────────────────────────────────────────────
  useEffect(() => {
    Promise.all([
      fetchTrending(),
      fetchTopRated(),
      fetchNowPlaying(),
      fetchByGenre(28),
      fetchByGenre(35),
      fetchByGenre(18),
    ])
    .then(([t, tr, np, ac, co, dr]) => {
      setTrending(t.data.results);
      setTopRated(tr.data.results);
      setNowPlaying(np.data.results);
      setAction(ac.data.results);
      setComedy(co.data.results);
      setDrama(dr.data.results);
    })
    .catch(console.error)
    .finally(() => setLoadingTmdb(false));
  }, []);

  // ── Firebase custom movies (real-time) ───────────────────────────
  useEffect(() => {
    const q = query(collection(db, 'customMovies'), orderBy('createdAt', 'desc'));
    return onSnapshot(q, snap =>
      setCustomMovies(snap.docs.map(d => normaliseCustom({ id: d.id, ...d.data() })))
    );
  }, []);

  // ── Build hero list: pinned custom first, then TMDB trending ─────
  const pinned     = customMovies.filter(m => m.featured);
  const heroMovies = [...pinned, ...trending].slice(0, 10);

  // ── Merge custom movies into Trending row (custom first) ─────────
  const trendingRow = [
    ...customMovies,
    ...trending.filter(t => !customMovies.find(c => c.title === t.title)),
  ];

  return (
    <div style={{ background: 'var(--dark)', minHeight: '100vh' }}>
      <Hero movies={heroMovies.length ? heroMovies : trending} />

      <div className="pt-10">
        {customMovies.length > 0 && (
          <MovieRow
            title="🎬 CineSpur Originals"
            movies={customMovies}
            loading={false}
            accent="#F5C518"
          />
        )}
        <MovieRow title="Trending This Week" movies={trendingRow}  loading={loadingTmdb} accent="#E50914" />
        <MovieRow title="Now Playing"        movies={nowPlaying}   loading={loadingTmdb} accent="#F5C518" />
        <MovieRow title="Top Rated"          movies={topRated}     loading={loadingTmdb} accent="#00C9FF" />
        <MovieRow title="Action"             movies={action}       loading={loadingTmdb} accent="#FF6B35" />
        <MovieRow title="Comedy"             movies={comedy}       loading={loadingTmdb} accent="#7ED321" />
        <MovieRow title="Drama"              movies={drama}        loading={loadingTmdb} accent="#BD10E0" />
      </div>

      <Footer />
    </div>
  );
};

export default HomePage;
